import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { IUser } from 'src/app/interfaces/user/UserRecord';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  public requestAPIurl: any = environment.apiURL;
  public userId: any;
  public headers: any;
  constructor(private http: HttpClient) {

  }


  public getUserDetails(id): Observable<IUser> {
    return this.http.get<IUser>(`${this.requestAPIurl}/api/user/${id}`);
  }

  public updateUserDetails(id, body) {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/user/${id}/modify`, body, { headers: this.headers })
  }

  public updateUserPhoto(id, photo) {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/user/${id}/modify/photo`, photo, { headers: this.headers })
  }

  public resetPassword(id, body) {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/user/${id}/resetpassword`, body, { headers: this.headers })
  }

  public getAllUsersDetails(body) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/admin/dashboard`, body, { headers: this.headers });
  }

  public generateOtp(body) {
    return this.http.post(`${this.requestAPIurl}/api/auth/otp/generate`, body);
  }

  public verifyOtp(body) {
    return this.http.post(`${this.requestAPIurl}/api/auth/otp/verify`, body);
  }

  public updatePassword(body) {
    return this.http.put(`${this.requestAPIurl}/api/user/updatepassword`, body);
  }

  public upgradeMembership(id, body) {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/user/${id}/upgradeMembership`, body, { headers: this.headers });
  }

  public cancelMembership(id) {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/user/${id}/cancelMembership`, { headers: this.headers });
  }

  public getSubscribedUsers() {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/user/getSubscribedUsers`, { headers: this.headers });
  }

  public restricUserSubscription(userId) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/admin/user/${userId}/restrictSubscription`, {}, { headers: this.headers });
  }

  public enableUserSubscription(userId, tenureInMonths) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/admin/user/${userId}/enableSubscription`, { tenureInMonths: tenureInMonths }, { headers: this.headers });
  }

  setHeaders() {
    if (JSON.parse(sessionStorage.getItem('logged-in-user'))) {
      this.userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
      this.headers = new HttpHeaders().set('id', this.userId);
    }
  }
}
